import { render } from "./AppHeader.vue?vue&type=template&id=39bd488e"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=39bd488e&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__